enum ButtonType {
    BUTTON = 'button',
    SUBMIT = 'submit',
    LINK = 'a',
    ROUTER_LINK = 'RouterLink',
}

enum ButtonTheme {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    TERTIARY = 'tertiary',
    TERTIARY_DARK = 'tertiary-dark',
    DANGER = 'danger',
    LIGHT = 'light',
    GREY_TO_RED = 'grey-to-red',
    RED_TO_GREY = 'red-to-grey',
    SIMPLE = 'simple',
    REVERSE_SIMPLE = 'reverse-simple',
    BACK_LES_TALENTS = 'back-les-talents',
    BACK_LE_CLUB = 'back-le-club',
    REVERSE_COLORED = 'reverse-colored',
}

enum ButtonSize {
    EXTRA_SMALL = 'extra-small',
    SMALL = 'small',
    LARGE = 'large',
}

export { ButtonType, ButtonTheme, ButtonSize }
